import { type UseQueryResult, useQuery } from 'react-query';
import * as wealthlaneCustomerServices from '../../services/wealthlane-customer-services';
import { DisbursementSharedService } from '../../services/wealthlane-award-settlement-services';

const useGetDisbursementStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const DisbursementStatus = useQuery(
    ['getDisbursementStatus'],
    async () => {
      return await handleRequest(
        DisbursementSharedService.getApiAwardSettlementApiAppDisbursementDisbursementStatus()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return DisbursementStatus;
};

export default useGetDisbursementStatus;
